type imagesListType = {
  [key: string]: { f: string; a: string; s: string; alt?: string }
}
export const DE: {
  list: imagesListType
} = {
  list: {
    intro: {
      f: 'i_casa4.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Vor einem Jahr befiel das Virus das Heim im Stadtteil Sementina. Und breitete sich auf sämtlichen Etagen aus.',
      alt: 'Foto des Altersheims teilweise verdeckt von Bäumen'
    },
    '2020-03-11': {
      f: 'i_giorgio.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        '«Seinen Esprit hat er nie verloren», sagt Valeria über ihren verstorbenen Ehemann Giorgio.',
      alt:
        'Foto einer Frau mit rotem Nagellack, die einen goldenen Bilderrahmen mit dem Foto eines Mannes hält.'
    },
    '2020-03-23': {
      f: 'i_casa2.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Im Fokus: Der Tessiner Kantonsarzt hat die Abläufe im Circolo del Ticino detailliert untersucht.',
      alt: 'Foto eines Schildes auf dem der Name des Altersheims steht.'
    },
    '2020-04-02': {
      f: 'i_alvara.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Martha sah ihre Mutter Alvara zum letzten mal während einem Videoanruf.',
      alt:
        'Foto einer Frau, welche das Foto ihrer Mutter in einem goldenen Bilderrahmen hält.'
    },
    '2020-06-01': {
      f: 'i_casa3.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Im Dilemma: Die Verantwortlichen des Circolo hatten vor einem Jahr schwere Entscheide zu fällen.',
      alt:
        'Foto des Altersheims aus der Perspektive einer Drohne über dem Haus.'
    }
  }
}
export const FR: {
  list: imagesListType
} = {
  list: {
    intro: {
      f: 'i_casa4.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Au printemps 2020, la maison de retraite de Bellinzone (TI) a été sévèrement touchée par le Covid.',
      alt:
        "Photo de l'EMS Il Circolo del Ticino, partiellement caché par les arbres"
    },
    '2020-03-11': {
      f: 'i_giorgio.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        '«Giorgio était un roc, il ne se laissait jamais aller», raconte Valeria à propos de son défunt mari',
      alt:
        "Photo d'une femme montrant avec fierté le portrait de son mari mort du Covid."
    },
    '2020-03-23': {
      f: 'i_casa2.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        "Le médecin cantonal tessinois a ouvert une enquête sur ce qui s'est passé dans l'EMS Il Circolo del Ticino. Un rapport critique a été rendu.",
      alt:
        "Photo d'un panneau qui indique le nom de la maison de retraite Il Circolo del Ticino à Bellinze (TI)."
    },
    '2020-04-07': {
      f: 'i_alvara.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        "Martha a vu sa mère Alvara pour la dernière fois lors d'une vidéoconférence, peu de temps avant sa mort.",
      alt:
        "Photo d'une femme, assise fiérement sur une chaise, qui tient le portrait de sa mère décédée du Covid."
    },
    '2020-06-01': {
      f: 'i_casa3.jpg',
      a: 'Ti-Press / Alessandro Crinari',
      s:
        'Le dilemme du Covid: la direction du Circolo a parfois dû prendre des décisions difficiles.',
      alt:
        'Photo en contre-plongée de la maison de retraite dans le quartier de Sementina à Bellinzone (TI).'
    }
  }
}
